export default __webpack_public_path__ + "static/1-b5f0174a2b02d14d46c6313ebe100322.jpg";